// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14xVf","inner":"Footer_inner__1oWo0","nextIcon":"Footer_nextIcon__24u7c","innerLeft":"Footer_innerLeft__1nqa2"};